<script>
    import {attributesLoad} from "../lib/requests";
    import AttributeEdit from "./AttributeEdit.svelte";

    let attributes = null;
    let categories = [];
    let total = 0;
    let loading = false;
    let selectedId = null;
    let editId = null;

    const load = async () => {
        loading = true;

        const [err, res] = await attributesLoad();

        if (err) {
            alert('error ' + err)
            return;
        }

        attributes = res.attributes;
        categories = res.categories;
        total = attributes.length;

        attributes.map(item => {
            item.needs_translation = needTranslations(item);
        });

        loading = false;
    }

    const needTranslations = obj => {
        if (obj.name_en == null || obj.name_en.length == 0) {
            return true;
        }

        let need = false;
        if (obj.data && obj.data.length > 0) {
            obj.data.map(value => {
                if ((value.el == null || value.el.length == 0) || (value.en == null || value.en.length == 0)) {
                    need = true;
                }
            });
        }

        return need;
    }

    const onEdit = item => {
        selectedId = item.id;
        editId = item.id;
    }

    const closeEdit = data => {
        editId = null;
        if (data !== undefined) {
            let item = attributes.find(x => x.id === data.id);
            if (item) {
                item.name_el = data.name_el;
                item.name_en = data.name_en;
                item.data = data.data;
                item.needs_translation = needTranslations(item);
            }
            attributes = attributes;
        }
    }

    load();
</script>

<div class="section-header">
    <div class="row">
        <div class="col-md-8">
            <button class="btn btn-primary" on:click="{ load }" title="Ανανέωση κατηγοριών"><i
                    class="fa fa-refresh"></i></button>
        </div>
    </div>
</div>

<div class="panel">
    <div class="panel-heading">
        <h2>Χαρακτηριστικά {total > 0 ? `(${total})` : ''}</h2>
    </div>
    <div class="panel-body fixed-height">
        <div class="panel-body-inner">
            {#if attributes != null}
                <table class="table">
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Όνομα</th>
                        <th>Τύπος</th>
                        <th>EmailAlert</th>
                        <th>Κατηγορίες</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each attributes as item}
                        <tr class:row-selected={selectedId == item.id}>
                            <td>{item.id}</td>
                            <td>
                                {#if item.needs_translation}
                                    <span class="icon" title="δεν έχει μεταφράσεις για όλα τα στοιχεία"><i
                                            class="fa fa-exclamation-triangle"></i></span>
                                {/if}
                                <button class="is-link" on:click={() => onEdit(item)}>{item.name_el}</button>
                            </td>
                            <td>{item.type}</td>
                            <td>
                                {#if item.show_on_emailalert == 1}
                                    <i class="fa fa-check"></i>
                                {/if}
                            </td>
                            <td>
                                {#if item.categories.length > 0}
                                    {item.categories[0].name}
                                {/if}
                                {#if +item.categories_count - 1 > 0}
                                    (+{+item.categories_count - 1})
                                {/if}
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
</div>

{#if editId != null}
    <AttributeEdit attributeId={editId} closeCallback={closeEdit}/>
{/if}

<style>
    .icon {
        color: red;
    }
</style>